module.exports = __webpack_public_path__ + "img/7.f4ab2c08.png";